import { isShortRoundMarket, type RoundRef } from '@/client/pages/btc-5m/round-index';

/**
 * Auto slippage per market class, in basis points. The tolerance covers only the price move between the quote
 * and the block that includes the trade. The trade's own price impact is already in the quote, so neither the
 * size nor the impact of a trade changes these values.
 *
 * The slippage fix must not block normal trades, so the values sit high.
 * 5m rounds: 20%, about the p95 of the adverse quote move in 10 s (19.3%; 400 external trades on 10/28).
 * Other markets: 3%, the same as the default manual slippage (14 days: no adverse move in 12 decoded trades).
 * Keep the constants easy to change.
 */
export const SHORT_AUTO_BPS = 2000;
export const OTHER_AUTO_BPS = 300;

export type MarketClass = 'short' | 'other';
export type MarketRef = { eventId?: string; eventTitle?: string; marketName?: string };

/** The one auto slippage function. Both trade paths and the settings display use it. */
export const autoSlippageBps = (marketClass: MarketClass): number =>
  marketClass === 'short' ? SHORT_AUTO_BPS : OTHER_AUTO_BPS;

/** A 5-minute round by title or by the rounds feed; unknown market data counts as other. */
export const classifyMarket = (market: MarketRef | undefined, index: Map<string, RoundRef>): MarketClass =>
  market && isShortRoundMarket(market, index) ? 'short' : 'other';
